import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  ERetailTransactionSortField,
  IRetailTransaction,
  PRetailTransactionFilter,
} from "src/core/retailTransaction/entities";
import { ActionType, createAction, getType } from "typesafe-actions";
import { EAuthRoles } from "src/core/auth/entities";

/*
 * state
 */
export interface IRetailTransactionState {
  retailTransactions: IRetailTransaction[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
}

const initialState: IRetailTransactionState = {
  retailTransactions: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "retail-transaction/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "retail-transaction/FETCH_SUCCEEDED";
const FETCH_FAILED = "retail-transaction/FETCH_FAILED";
const POLLING_START_REQUESTED = "retail-transaction/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "retail-transaction/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRetailTransaction[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<unknown>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    role: EAuthRoles;
    filter: PRetailTransactionFilter;
    pagination: IPagination;
    sorts: ISort<ERetailTransactionSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRetailTransactionState, TActions> = (state = initialState, action) => {
  return produce<IRetailTransactionState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.retailTransactions = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
